// extracted by mini-css-extract-plugin
export default {"unchecked":"checkbox_unchecked__Tensb","checked":"checkbox_checked__fUlBP","bigCheck":"checkbox_bigCheck__EVpZO"};